document.querySelector('.header__inline-menu ul.list-menu li')?.classList.add('cartridge-finder-menu');

document.addEventListener('DOMContentLoaded', function () {
  const viewButtons = document.querySelectorAll('.view-toggle__btn');
  const productList = document.querySelector('.product-grid');

  if (!viewButtons.length || !productList) return;

  // Function to update view
  function updateView(view) {
    // Remove existing classes
    productList.classList.remove('data-view-grid', 'data-view-list');

    // Add selected class
    productList.classList.add(`data-view-${view}`);

    // Update active button
    viewButtons.forEach(button => {
      const isActive = button.dataset.view === view;
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  // Set default view on page load
  const activeButton = document.querySelector(
    '.view-toggle__btn[aria-pressed="true"]'
  );

  const defaultView = activeButton
    ? activeButton.dataset.view
    : 'grid';

  updateView(defaultView);

  // Handle button clicks
  viewButtons.forEach(button => {
    button.addEventListener('click', function () {
      updateView(this.dataset.view);
    });
  });
});

(function () {
  var root = document.documentElement;
  var TOGGLE_HTML =
    '<div class="view-toggle" role="group" aria-label="Product view">' +
      '<button type="button" class="view-toggle__btn" data-view="grid" aria-label="Grid view">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">' +
          '<rect x="2" y="2" width="7" height="7" rx="1"/><rect x="11" y="2" width="7" height="7" rx="1"/>' +
          '<rect x="2" y="11" width="7" height="7" rx="1"/><rect x="11" y="11" width="7" height="7" rx="1"/>' +
        '</svg></button>' +
      '<button type="button" class="view-toggle__btn" data-view="list" aria-label="List view">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">' +
          '<rect x="2" y="3" width="16" height="3" rx="1"/><rect x="2" y="8.5" width="16" height="3" rx="1"/>' +
          '<rect x="2" y="14" width="16" height="3" rx="1"/>' +
        '</svg></button>' +
    '</div>';

  function currentView() {
    return root.classList.contains('view-grid') ? 'grid' : 'list';
  }

  function syncButtons() {
    document.querySelectorAll('.view-toggle__btn').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.view === currentView() ? 'true' : 'false');
    });
  }

  function setView(view) {
    root.classList.remove('view-grid', 'view-list');
    root.classList.add('view-' + view);
    try { localStorage.setItem('collection-view', view); } catch (e) {}
    syncButtons();
  }

  function inject() {
    if (document.querySelector('.view-toggle')) return;

    // Try the sort dropdown first, then fall back to the product count
    var anchor =
      document.querySelector('#SortBy') ||
      document.querySelector('.facet-filters__sort') ||
      document.querySelector('.product-count') ||
      document.querySelector('#ProductCount');
    if (!anchor) return;

    // Insert after the whole sort field / row, not inside the <select>
    var target = anchor.closest('.facet-filters__field') || anchor.closest('.facet-filters') || anchor;
    target.insertAdjacentHTML('afterend', TOGGLE_HTML);
    syncButtons();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.view-toggle__btn');
    if (btn) setView(btn.dataset.view);
  });

  inject();
  document.addEventListener('DOMContentLoaded', inject);

  // Re-inject after Dawn's AJAX re-render (filter / sort / pagination)
  new MutationObserver(inject).observe(document.body, { childList: true, subtree: true });
})();